import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Hummingbird } from "../components/Hummingbird";

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            navigate("/login", { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(m[1]);

        (async () => {
            try {
                const r = await api.post("/auth/google", { session_id: sessionId });
                setUser(r.data);
                // Clean hash and go to dashboard
                window.history.replaceState({}, "", "/dashboard");
                navigate("/dashboard", { replace: true, state: { user: r.data } });
            } catch (e) {
                const msg = e?.response?.data?.detail || "Sign-in failed";
                navigate("/login", { replace: true, state: { error: msg } });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen w-full flex items-center justify-center bg-[#F9F8F3]" data-testid="auth-callback">
            <div className="text-center">
                <div className="hummingbird-float inline-block">
                    <Hummingbird size={64} />
                </div>
                <p className="mt-4 text-[#57675F] font-display">Welcoming you in…</p>
            </div>
        </div>
    );
}
